/** Dispatch event on click outside of node */
export function clickOutside(node: HTMLElement) {
	// console.log('clickOutside - 00:', node)

	const handleClick = (event: MouseEvent) => {
		console.log('clickOutside - 01:', node, event)
		
		const evtTarget = event?.target
		if(!evtTarget) return

		// Check the special class to prevent clickOutside
		const skipClickOutside = (evtTarget as HTMLElement).classList.contains('skip-clickOutside')
		// console.log('clickOutside - 02:', skipClickOutside, evtTarget)

		if (skipClickOutside) {
			// Check the special attribute to see if the skip  is for this element (Optional)
			const mainClickOutside = (evtTarget as HTMLElement).getAttribute('main-clickoutside')
			// console.log('clickOutside - 03:', mainClickOutside, skipClickOutside, node.id)

			if (mainClickOutside) {
				if (mainClickOutside.indexOf(node.id) >= 0) {
					// console.log('clickOutside - 04 - same Main:', mainClickOutside, skipClickOutside, node.id)
					return
				}
			} else {
				return
			}
		}

		if (node && !node.contains(event.target as Node) && !event.defaultPrevented) {
			// console.log('clickOutside - 04:', node, event)
			node.dispatchEvent(new CustomEvent('click_outside', { detail: node }))
		}
	}

	document.addEventListener('click', handleClick, true)

	return {
		destroy() {
			document.removeEventListener('click', handleClick, true)
		}
	}
}
